import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { KpiResultFragment, KpiType } from "@ankaadia/graphql";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiKpiCarouselPanelComponent } from "../kpi-carousel-panel/new-ui-kpi-carousel-panel.component";

@Component({
  selector: "new-ui-kpi-carousel-view",
  templateUrl: "./new-ui-kpi-carousel-view.component.html",
  styleUrl: "./new-ui-kpi-carousel-view.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, NewUiKpiCarouselPanelComponent],
})
export class NewUiKpiCarouselViewComponent {
  readonly candidateKpis = input.required<KpiResultFragment[]>();
  readonly organizationKpis = input.required<KpiResultFragment[]>();
  readonly revenueKpis = input.required<KpiResultFragment[]>();
  readonly accountsReceivableKpis = input.required<KpiResultFragment[]>();
  readonly currentPanelIndex = input.required<number>();
  readonly prevIndex = input.required<number>();
  readonly nextIndex = input.required<number>();

  readonly panelChange = output<number>();

  readonly KpiType = KpiType;

  goToPanel(index: number): void {
    this.panelChange.emit(index);
  }
}
